import React from "react";

import { OriginatorsDataProvider } from "../../../common/data/lookup-data-providers/OriginatorsDataProvider";
import { DeliveryBucketListingProvider } from "../context/DeliveryBucketListingProvider";
import { DeliveryBucketListing } from "./DeliveryBucketListing";

export const DeliveryBucketListingDashboard: React.VFC = () => {
    return (
        <OriginatorsDataProvider>
            <DeliveryBucketListingProvider>
                <DeliveryBucketListing />
            </DeliveryBucketListingProvider>
        </OriginatorsDataProvider>
    );
};
